import React, { useState, useEffect, useRef } from "react";
import AccessoriesListing from "./AccessoriesListing";
import Spinner from "./Spinner";

const Accessories = ({ productCode }) => {
    const [relatedAccessories, setRelatedAccessories] = useState([]);
    const [loading, setLoading] = useState(false);
    const hasCalledAPI = useRef(false);

    useEffect(() => {
        const hash = window.location.hash.substring(1);
        const tabBtn = document.querySelector("#product-tab3");

        const handleTabClick = () => {
            if (!hasCalledAPI.current) {
                getRelatedAccessories();
            }
        };

        tabBtn?.addEventListener("click", handleTabClick);

        if (hash.toLowerCase().includes("accessories") && !hasCalledAPI.current) {
            getRelatedAccessories();
        }

        return () => {
            tabBtn?.removeEventListener("click", handleTabClick);
        };
    }, []);

    const getRelatedAccessories = () => {
        if (hasCalledAPI.current) return;

        setLoading(true);
        hasCalledAPI.current = true;

        fetch(i18n.baseUrl + `api/productaccessories/accessories?productCode=${productCode}`)
            .then((res) => res.json())
            .then((json) => {
                setRelatedAccessories(json);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching accessories:", error);
                setLoading(false);
            });
    };

    return (
        <div className="c-series c-series__listing">
            {loading && <Spinner />}
            {relatedAccessories.map((rp) => (
                <AccessoriesListing
                    key={rp.productCode}
                    productCode={rp.productCode}
                    productUrl={rp.productUrl}
                    productName={rp.productName}
                />
            ))}
        </div>
    );
};

export default Accessories;